import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '¿Para qué tipo de pareja es este material?',
    a: 'Para cualquier pareja que quiera mejorar su relación: recién casados, parejas con años juntos, parejas en crisis o parejas que simplemente quieren herramientas para crecer. El lenguaje y los ejemplos están adaptados a la realidad latinoamericana actual.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibís un correo con el acceso a todos los PDFs. En menos de 5 minutos podés estar leyendo el primer tomo.'
  }, {
    q: '¿Lo pueden usar aunque solo uno quiera hacerlo?',
    a: 'Sí. Muchos protocolos pueden iniciarse por una sola persona. Y cuando uno empieza a cambiar la dinámica, el otro generalmente se suma. Dicho esto, los mejores resultados los tienen las parejas donde ambos participan.'
  }, {
    q: '¿Qué lo diferencia de un libro de autoayuda o de terapia?',
    a: 'No es teoría para leer y guardar. Es un sistema práctico con protocolos, guiones, plantillas y acuerdos para usar en la vida real. No reemplaza la terapia profesional cuando se necesita, pero sí puede complementarla o ser el primer paso antes de llegar a ella.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total sin preguntas. Si no te sirve, te devolvemos el 100% del dinero. Sin formularios, sin demoras.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-900" data-id="element-54">
      <div className="max-w-3xl mx-auto" data-id="element-55">
        <div className="text-center mb-12" data-id="element-56">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-57">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-4" data-id="element-58">
          {faqs.map((faq, index) => <div key={index} className="bg-navy-800 border border-navy-700 rounded-2xl overflow-hidden transition-colors hover:border-navy-600" data-id="element-59">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-60">
                <span className="font-semibold text-lg text-white pr-8" data-id="element-61">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-blue-400 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-62" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-63">
                <div className="px-6 pb-6 text-slate-300 leading-relaxed border-t border-navy-700/50 pt-4 mt-2" data-id="element-64">
                  {faq.a}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}